import React from "react";
import { Mangedevices, SendLogoutpin, userprofile } from "../../Model/Users"; //Include Home
import { withRouter, VirsionCheck } from "../../Helpers/Common";
import { UserchangeSendpin, verifylogout } from "../../Model/Users";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { motion } from "framer-motion";
import * as CountryCode from "../../Config/CountryCode.js";
import { Link } from "react-router-dom";
import Profilemenu from "../Profile_menu/Profilemenu";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { isMobile } from "react-device-detect";
import PinsendLayout from "./pinsend";
import { Metadata } from "../Metadata/Metadata";
import BarLoader from "react-spinners/BarLoader";
var SVGIcon = "";
var ImageData = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));
class Managedevices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      MangedevicesData: false,
      VirsionCheckData: false,
      VirsionCheckDataloaded: false,
      userData: false,
      Pinsend: false
    };
    this.submitVerifypinForm = this.submitVerifypinForm.bind(this);
  }

  componentDidMount() {
    //Get Virsion Check Data
    VirsionCheck().then((vcheckres) => {
      Mangedevices().then((Mangedevicesres) => {
        if (Mangedevicesres.data.success == false) {
          this.props.navigate("/createaccount");
        } else {
          let data = {
            seesionID:localStorage.getItem("session_id"),
            userID:localStorage.getItem("userID")
          }
          userprofile(data).then((userDatares) => {
            var userDatares = JSON.parse(userDatares.data.message);
            this.setState({
              VirsionCheckData: vcheckres,
              VirsionCheckDataloaded: true,
              MangedevicesData: Mangedevicesres,
              Logoutsessid: false,
              userData: userDatares.user_data,
              userchecked: userDatares.user_data.is_child,
              userId: userDatares.user_data.ID
            });
          })

        }
      });
    });
  }

  formatAMPM = (date) => {
    var ss = new Date(date).toDateString();
    return ss;
  }

  logoutDevice(id, sessionid) {
    this.setState({
      Showpop: true
    });
    this.setState({
      Logoutsessid: id,
      sessionid: sessionid
    })
    // SendLogoutpin().then((sendpinRes) => {
    //   var sendpinRes = JSON.parse(sendpinRes.data);
    //   if (sendpinRes.success == true) {
    //     this.setState({
    //       Pinsend: true,
    //       Logoutsessid: sendpinRes
    //     })
    //   } else {
    //     this.setState({
    //       Pinsend: false
    //     })
    //   }
    // })
    // this.setState({ Pinsend: true });
  }

  CustomeBackButton() {
    this.setState({
      Pinsend: false,
    });
  }

  popupmodal() {
    return (
      <>
        <div className="temp31">
          <div className="temp31Inner">
            <div
              className="passChangepopup"
              style={{
                display: this.state.Showpop
                  ? "flex"
                  : "none",
              }}
              id="passChange"
            >
              <div className="temp31-modal-body">
                <button
                  className="temp31-modal-close temp31-modal-toggle"
                  onClick={() => this.setState({
                    Showpop: false
                  })}
                >
                  <img
                    src={SVGIcon["promocode-close.svg"]}
                    alt="DocuBay"
                  />
                </button>
                <img
                  src={ImageData["manage-devices.png"]}
                  alt="DocuBay"
                  className="imgPass"
                />
                <div className="temp31-awesome">
                  <h5>Log Out</h5>
                  <h6>Are you sure you want to log out of this devices?</h6>
                </div>
                <button
                  onClick={(e) => { this.submitVerifypinForm(e) }}

                  type="submit"
                  id="sendEnquiryBtn"
                  className="btn-white"
                >
                  Yes
                </button>
                <button
                  onClick={() => this.setState({
                    Showpop: false
                  })}
                  type="submit"
                  id="sendEnquiryBtn"
                  className="btn-white"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  submitVerifypinForm(e) {
    e.preventDefault();
    var postdata = {
      logout_sessionid: this.state.Logoutsessid,
      user_id: this.state.userId,
      session_id: this.state.sessionid,
    };


    verifylogout(postdata).then((res) => {
      var VerifyPinResp = JSON.parse(res.data);

      if (VerifyPinResp.success == true) {

        this.setState({
          Showpop: false
        });
        VirsionCheck().then((vcheckres) => {
          Mangedevices().then((Mangedevicesres) => {
            if (Mangedevicesres.data.success == false) {
              this.props.navigate("/createaccount");
            } else {
              let data = {
                seesionID:localStorage.getItem("session_id"),
                userID:localStorage.getItem("userID")
              }
              userprofile(data).then((userDatares) => {
                var userDatares = JSON.parse(userDatares.data.message);
                this.setState({
                  VirsionCheckData: vcheckres,
                  VirsionCheckDataloaded: true,
                  MangedevicesData: Mangedevicesres,
                  Logoutsessid: false,
                  userData: userDatares.user_data,
                  userchecked: userDatares.user_data.is_child,
                  userId: userDatares.user_data.ID
                });
              })

            }
          });
        });
        this.props.navigate("/manage-devices")

      } else {
        //this.props.data.popupshow();
        this.setState({
          Showpop: false
        });
      }
    });
  }



  /*-------Logout-------*/
  backbtn() {
    this.props.navigate("/manage-profile");
  }

  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    }
    // else if (this.state.Pinsend) {
    //   return (<PinsendLayout data={this} />)
    // }
    else {

      return (

        <>
          <Metadata page="MANAGE-DEVICE" />
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            key="1"
          >
            <>
              <div>
                <header>
                  <div className="mainNav pmenu dD-none">
                    <div className="manageD">
                      <Link to="/manage-profile">
                        <img src={SVGIcon["back.svg"]} alt="DocuBay" />
                      </Link>
                      <div className="manageDtext">
                        <h3>Manage Devices</h3>
                        <h6>Devices currently logged into your account</h6>
                      </div>
                    </div>
                  </div>
                  {/* <div className="manageD">
                    <Link to="/manage-profile">
                      <img src={SVGIcon["back.svg"]} alt="Docubay" />
                    </Link>
                  </div> */}
                </header>
                <main className="dD-none">
                  <section className="mb-0">
                    <div className="temp56">
                      <img src={ImageData["manage-devices.png"]} alt="" />
                    </div>
                  </section>
                  <section className="mb-0">
                    <div className="temp57">
                      <div className="temp57-inn">
                        <div className="temp57-area">
                          <img
                            src={SVGIcon["crome.svg"]}
                            className="img1"
                            alt="DocuBay"
                          />
                        </div>
                        <div className="temp57-right p-0">
                          <h5>Chrome Browser on Windows ( This Device)</h5>
                          <h6>{this.formatAMPM(this.state.MangedevicesData.data.existingDevice.created_at)}</h6>
                        </div>
                      </div>
                      {
                        this.state.MangedevicesData.data.sessions.map((data, index) => {

                          if (data.device_name == "Web") {

                            return (<div className="temp57-inn">
                              <div className="temp57-area">
                                <img
                                  src={ImageData["crome.png"]}
                                  className="img2"
                                  alt="DocuBay"
                                  maxWidth="2%"
                                />
                              </div>
                              <div className="temp57-right p-0">
                                <h5>Web </h5>
                                <h6>{this.formatAMPM(data.created_at)}</h6>
                              </div>
                              <button
                                type="submit"
                                id="sendEnquiryBtn"
                                className="btn-logOut"
                                onClick={() => {
                                  this.logoutDevice(data.id, this.state.MangedevicesData.data.existingDevice.id);
                                }}
                              >
                                {" "}
                                Log Out{" "}
                              </button>
                            </div>)
                          } else if (data.device_name == "iPhone") {

                            return (<div className="temp57-inn">
                              <div className="temp57-area">
                                <img
                                  src={SVGIcon["iphone.svg"]}
                                  className="img2"
                                  alt="DocuBay"
                                />
                              </div>
                              <div className="temp57-right p-0">
                                <h5>{data.device_name} {data.os_version} </h5>
                                <h6>{this.formatAMPM(data.created_at)}</h6>
                              </div>
                              <button
                                type="submit"
                                id="sendEnquiryBtn"
                                className="btn-logOut"
                                onClick={() => {
                                  this.logoutDevice(data.id, this.state.MangedevicesData.data.existingDevice.id);
                                }}
                              >
                                {" "}
                                Log Out{" "}
                              </button>
                            </div>)
                          } else if (data.device_name == "Android") {
                            return (<div className="temp57-inn">
                              <div className="temp57-area">
                                <img
                                  src={SVGIcon["iphone.svg"]}
                                  className="img2"
                                  alt="DocuBay"
                                />
                              </div>
                              <div className="temp57-right p-0">
                                <h5>{data.device_name} {data.os_version}</h5>
                                <h6>{this.formatAMPM(data.created_at)}</h6>
                              </div>
                              <button
                                type="submit"
                                id="sendEnquiryBtn"
                                className="btn-logOut"
                                onClick={() => {
                                  this.logoutDevice(data.id, this.state.MangedevicesData.data.existingDevice.id);
                                }}
                              >
                                {" "}
                                Log Out{" "}
                              </button>
                            </div>)
                          }
                        })
                      }
                    </div>
                  </section>
                </main>
                <main>
                  <section style={{ paddingBottom: 45 }} className="dD-none">
                    {this.popupmodal()}
                  </section>
                </main>
                {/* <Mobilemenu active="5" /> */}
              </div>

              <>
                <div className="dD-block">
                  <div className="profile-back-desk dD-block">
                    <Link to="/profile">
                      <div className="docubayBack white">
                        <img src={SVGIcon["back.svg"]} alt="DocuBay" />
                      </div>
                    </Link>
                  </div>
                  <main className="setting-main dD-block">
                    <section className="mb-0">
                      <div className="temp566-text dD-block">
                        <h3>Manage Device</h3>
                        <p>Devices currently logged to your account</p>
                      </div>
                      <div className="temp56">
                        <img src={ImageData["manage-devices.png"]} alt="" />
                      </div>
                      <div className="temp57">
                        <div className="temp57-inn">
                          <div className="temp57-area">
                            <img src={SVGIcon["crome.svg"]} className="img1" alt="DocuBay" />
                          </div>
                          <div className="temp57-right p-0">
                            <h5>Chrome Browser on Windows ( This Device)</h5>
                            <h6>{this.formatAMPM(this.state.MangedevicesData.data.existingDevice.created_at)}</h6>
                          </div>
                        </div>
                        {
                          this.state.MangedevicesData.data.sessions.map((data, index) => {

                            if (data.device_name == "Web") {

                              return (<div className="temp57-inn">
                                <div className="temp57-area">
                                  <img
                                    src={ImageData["crome.png"]}
                                    className="img2"
                                    alt="DocuBay"
                                    maxWidth="2%"
                                  />
                                </div>
                                <div className="temp57-right p-0">
                                  <h5>Web </h5>
                                  <h6>{this.formatAMPM(data.created_at)}</h6>
                                </div>
                                <button
                                  type="submit"
                                  id="sendEnquiryBtn"
                                  className="btn-logOut"
                                  onClick={() => {
                                    this.logoutDevice(data.id, this.state.MangedevicesData.data.existingDevice.id);
                                  }}
                                >
                                  {" "}
                                  Log Out{" "}
                                </button>
                              </div>)
                            } else if (data.device_name == "iPhone") {

                              return (<div className="temp57-inn">
                                <div className="temp57-area">
                                  <img
                                    src={SVGIcon["iphone.svg"]}
                                    className="img2"
                                    alt="DocuBay"
                                  />
                                </div>
                                <div className="temp57-right p-0">
                                  <h5>{data.device_name} {data.os_version} </h5>
                                  <h6>{this.formatAMPM(data.created_at)}</h6>
                                </div>
                                <button
                                  type="submit"
                                  id="sendEnquiryBtn"
                                  className="btn-logOut"
                                  onClick={() => {
                                    this.logoutDevice(data.id, this.state.MangedevicesData.data.existingDevice.id);
                                  }}
                                >
                                  {" "}
                                  Log Out{" "}
                                </button>
                              </div>)
                            } else if (data.device_name == "Android") {
                              return (<div className="temp57-inn">
                                <div className="temp57-area">
                                  <img
                                    src={SVGIcon["iphone.svg"]}
                                    className="img2"
                                    alt="DocuBay"
                                  />
                                </div>
                                <div className="temp57-right p-0">
                                  <h5>{data.device_name} {data.os_version}</h5>
                                  <h6>{this.formatAMPM(data.created_at)}</h6>
                                </div>
                                <button
                                  type="submit"
                                  id="sendEnquiryBtn"
                                  className="btn-logOut"
                                  onClick={() => {
                                    this.logoutDevice(data.id, this.state.MangedevicesData.data.existingDevice.id);
                                  }}
                                >
                                  {" "}
                                  Log Out{" "}
                                </button>
                              </div>)
                            }
                          })
                        }
                      </div>
                    </section>
                  </main>
                  <main>
                    <section style={{ paddingBottom: 45 }} className="dD-block">
                      {this.popupmodal()}
                    </section>
                  </main>
                </div>
                <Profilemenu versioncheck={this.state.VirsionCheckData} profile={this.state.userData} />
              </>
              {/* <Mobilemenu active="5"/> */}
            </>
          </motion.div>
        </>
      );
    }
  }
}
export default withRouter(Managedevices);
